import { useState, useMemo } from "react";

const PROXY    = process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const getToken = () => localStorage.getItem("sellsync_token");

const INR   = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
const PCT   = (n) => Number(n || 0).toFixed(1) + "%";
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

// ── Indian state code map ─────────────────────────────────────
const STATE_CODES = {
  "andhra pradesh":"AP","arunachal pradesh":"AR","assam":"AS","bihar":"BR",
  "chhattisgarh":"CG","goa":"GA","gujarat":"GJ","haryana":"HR",
  "himachal pradesh":"HP","jharkhand":"JH","karnataka":"KA","kerala":"KL",
  "madhya pradesh":"MP","maharashtra":"MH","manipur":"MN","meghalaya":"ML",
  "mizoram":"MZ","nagaland":"NL","odisha":"OD","punjab":"PB","rajasthan":"RJ",
  "sikkim":"SK","tamil nadu":"TN","telangana":"TG","tripura":"TR",
  "uttar pradesh":"UP","uttarakhand":"UK","west bengal":"WB",
  "delhi":"DL","jammu and kashna":"JK","jammu & kashmir":"JK","ladakh":"LA",
  "chandigarh":"CH","puducherry":"PY","pondicherry":"PY",
  "andaman and nicobar":"AN","andaman & nicobar":"AN",
  "dadra and nagar haveli":"DN","dadra & nagar haveli":"DN",
  "daman and diu":"DD","daman & diu":"DD","lakshadweep":"LD",
  "ap":"AP","ar":"AR","as":"AS","br":"BR","cg":"CG","ga":"GA","gj":"GJ",
  "hr":"HR","hp":"HP","jh":"JH","ka":"KA","kl":"KL","mp":"MP","mh":"MH",
  "mn":"MN","ml":"ML","mz":"MZ","nl":"NL","od":"OD","pb":"PB","rj":"RJ",
  "sk":"SK","tn":"TN","tg":"TG","tr":"TR","up":"UP","uk":"UK","wb":"WB",
  "dl":"DL","jk":"JK","la":"LA","ch":"CH","py":"PY",
};

const GST_STATE_CODES = {
  "AP":"37","AR":"12","AS":"18","BR":"10","CG":"22","GA":"30","GJ":"24",
  "HR":"06","HP":"02","JH":"20","KA":"29","KL":"32","MP":"23","MH":"27",
  "MN":"14","ML":"17","MZ":"15","NL":"13","OD":"21","PB":"03","RJ":"08",
  "SK":"11","TN":"33","TG":"36","TR":"16","UP":"09","UK":"05","WB":"19",
  "DL":"07","JK":"01","LA":"38","CH":"04","PY":"34","AN":"35","DN":"26",
  "DD":"25","LD":"31",
};

function getStateCode(order) {
  const addr = order.shipping_address || order.billing_address || {};
  const province = (addr.province || addr.province_code || "").toLowerCase().trim();
  const city     = (addr.city || "").toLowerCase().trim();
  if (!province && !city) return "XX";
  return STATE_CODES[province] || STATE_CODES[city] || province.toUpperCase().slice(0,2) || "XX";
}

const PLATFORMS = [
  { id:"shopify",  name:"Shopify",  color:"#5a8a00", bg:"#f3f9ec" },
  { id:"amazon",   name:"Amazon",   color:"#c45000", bg:"#fff3e8" },
  { id:"flipkart", name:"Flipkart", color:"#1b57c0", bg:"#ebf2ff" },
  { id:"myntra",   name:"Myntra",   color:"#b5003c", bg:"#fff0f4" },
];

const S = {
  card:    { background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 },
  cardHdr: { padding:"11px 16px", borderBottom:"1px solid #e5e7eb", display:"flex", alignItems:"center", justifyContent:"space-between", fontWeight:600, fontSize:13 },
  th:      { padding:"8px 12px", textAlign:"left", fontSize:11, fontWeight:600, color:"#6b7280", background:"#f9fafb", whiteSpace:"nowrap" },
  thR:     { padding:"8px 12px", textAlign:"right", fontSize:11, fontWeight:600, color:"#6b7280", background:"#f9fafb", whiteSpace:"nowrap" },
  td:      { padding:"9px 12px", borderBottom:"1px solid #f3f4f6", verticalAlign:"middle", fontSize:13 },
  tdR:     { padding:"9px 12px", borderBottom:"1px solid #f3f4f6", verticalAlign:"middle", fontSize:13, textAlign:"right" },
  btn:     (c="#F47920") => ({ padding:"6px 14px", borderRadius:7, fontSize:12, cursor:"pointer", background:c, color:"#fff", border:"none", fontFamily:"inherit", fontWeight:600 }),
  btnOut:  { padding:"6px 14px", borderRadius:7, fontSize:12, cursor:"pointer", background:"#fff", color:"#374151", border:"1px solid #d1d5db", fontFamily:"inherit" },
  tab:     (a) => ({ padding:"10px 20px", background:"none", border:"none", borderBottom:a?"2px solid #F47920":"2px solid transparent", color:a?"#F47920":"#6b7280", fontWeight:a?600:400, fontSize:13, cursor:"pointer", fontFamily:"inherit" }),
  kpi:     { background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", padding:"14px 16px" },
  sel:     { padding:"6px 10px", borderRadius:7, border:"1px solid #d1d5db", fontSize:12, fontFamily:"inherit", outline:"none" },
};

const Badge = ({ label, color, bg }) => (
  <span style={{ background:bg, color, padding:"2px 9px", borderRadius:20, fontSize:11, fontWeight:600, whiteSpace:"nowrap" }}>{label}</span>
);

function BarChart({ data, color="#F47920", height=120 }) {
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div style={{ display:"flex", alignItems:"flex-end", gap:6, height, padding:"0 4px" }}>
      {data.map((d, i) => (
        <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:4 }}>
          <div style={{ fontSize:10, color:"#6b7280", fontWeight:600 }}>{d.value > 0 ? INR(d.value).replace("₹","") : ""}</div>
          <div style={{ width:"100%", background:color, borderRadius:"3px 3px 0 0", height:Math.max(4,(d.value/max)*(height-30)), opacity:0.85 }}/>
          <div style={{ fontSize:10, color:"#9ca3af", textAlign:"center" }}>{d.label}</div>
        </div>
      ))}
    </div>
  );
}

export default function PageGST({ toast, orders=[], invoices=[], products=[] }) {
  const [tab,     setTab]     = useState("analytics");
  const [gstTab,  setGstTab]  = useState("gstr1");
  const [aiGst,   setAiGst]   = useState(null);
  const [aiLoading,setAiLoading]= useState(false);
  const [filingInput, setFilingInput] = useState([
    { month:"", taxableSales:0, cgst:0, sgst:0, igst:0, totalGst:0, platformSettlement:0 }
  ]);
  const [uploadedStatement, setUploadedStatement] = useState(null);
  const [month,   setMonth]   = useState(new Date().getMonth());
  const [year,    setYear]    = useState(new Date().getFullYear());
  const [platFilter, setPlatFilter] = useState("all");

  const years = [year-2, year-1, year, year+1];

  // ── build unified sales from all platforms ────────────────────
  const allSales = useMemo(() => {
    const shopifySales = orders.map((o) => {
      const total   = parseFloat(o.total_price || 0);
      const taxable = Math.round(total / 1.18);
      const gst     = total - taxable;
      const stCode  = getStateCode(o);
      return {
        id:         o.name || o.id,
        date:       new Date(o.created_at),
        platform:   "shopify",
        customer:   o.customer ? o.customer.first_name + " " + o.customer.last_name : "Guest",
        stateCode:  stCode,
        gstStateCode: GST_STATE_CODES[stCode] || "00",
        city:       (o.shipping_address?.city || ""),
        total,
        taxable:    Math.round(taxable),
        gst:        Math.round(gst),
        cgst:       Math.round(gst / 2),
        sgst:       Math.round(gst / 2),
        igst:       0,
        gstRate:    18,
      };
    });

    const invoiceSales = invoices.map((inv) => ({
      id:           inv.id,
      date:         new Date(inv.date),
      platform:     inv.platform,
      customer:     inv.customer,
      stateCode:    "XX",
      gstStateCode: "00",
      city:         inv.address || "",
      total:        inv.total,
      taxable:      Math.round(inv.total / 1.18),
      gst:          Math.round(inv.total - inv.total / 1.18),
      cgst:         Math.round((inv.total - inv.total / 1.18) / 2),
      sgst:         Math.round((inv.total - inv.total / 1.18) / 2),
      igst:         0,
      gstRate:      18,
    }));

    return [...shopifySales, ...invoiceSales];
  }, [orders, invoices]);

  // ── filtered sales ────────────────────────────────────────────
  const periodSales = useMemo(() =>
    allSales.filter((s) => {
      const inPeriod = s.date.getMonth() === month && s.date.getFullYear() === year;
      const inPlat   = platFilter === "all" || s.platform === platFilter;
      return inPeriod && inPlat;
    }), [allSales, month, year, platFilter]);

  // ── state-wise summary ────────────────────────────────────────
  const stateWise = useMemo(() => {
    const map = {};
    periodSales.forEach((s) => {
      const key = s.stateCode || "XX";
      if (!map[key]) map[key] = { stateCode:key, gstCode:s.gstStateCode, orders:0, taxable:0, cgst:0, sgst:0, igst:0, total:0 };
      map[key].orders++;
      map[key].taxable += s.taxable;
      map[key].cgst    += s.cgst;
      map[key].sgst    += s.sgst;
      map[key].igst    += s.igst;
      map[key].total   += s.total;
    });
    return Object.values(map).sort((a, b) => b.total - a.total);
  }, [periodSales]);

  // ── totals ────────────────────────────────────────────────────
  const totals = useMemo(() => ({
    revenue:  allSales.reduce((a, s) => a + s.total, 0),
    gst:      allSales.reduce((a, s) => a + s.gst, 0),
    taxable:  allSales.reduce((a, s) => a + s.taxable, 0),
    orders:   allSales.length,
    avg:      allSales.length > 0 ? allSales.reduce((a, s) => a + s.total, 0) / allSales.length : 0,
  }), [allSales]);

  const periodTotals = useMemo(() => ({
    taxable: periodSales.reduce((a, s) => a + s.taxable, 0),
    cgst:    periodSales.reduce((a, s) => a + s.cgst, 0),
    sgst:    periodSales.reduce((a, s) => a + s.sgst, 0),
    igst:    periodSales.reduce((a, s) => a + s.igst, 0),
    total:   periodSales.reduce((a, s) => a + s.total, 0),
    orders:  periodSales.length,
  }), [periodSales]);

  // ── monthly chart ─────────────────────────────────────────────
  const monthlyData = useMemo(() => Array.from({ length:6 }, (_, i) => {
    const d = new Date(); d.setMonth(d.getMonth() - (5 - i));
    const m = d.getMonth(), y = d.getFullYear();
    const val = allSales.filter((s) => s.date.getMonth()===m && s.date.getFullYear()===y).reduce((a,s)=>a+s.total,0);
    return { label:MONTHS[m], value:Math.round(val) };
  }), [allSales]);

  // ── platform breakdown ────────────────────────────────────────
  const platData = useMemo(() => PLATFORMS.map((pl) => {
    const sales = allSales.filter((s) => s.platform === pl.id);
    const rev   = sales.reduce((a, s) => a + s.total, 0);
    return { ...pl, revenue:rev, orders:sales.length, pct: totals.revenue > 0 ? (rev/totals.revenue)*100 : 0 };
  }).filter((p) => p.revenue > 0), [allSales, totals.revenue]);

  // ── SKU data ──────────────────────────────────────────────────
  const skuData = useMemo(() => {
    const map = {};
    orders.forEach((o) => {
      (o.line_items||[]).forEach((item) => {
        const k = item.name||item.title||"Unknown";
        if (!map[k]) map[k] = { name:k, qty:0, revenue:0, orders:0 };
        map[k].qty     += item.quantity||1;
        map[k].revenue += parseFloat(item.price||0) * (item.quantity||1);
        map[k].orders  += 1;
      });
    });
    return Object.values(map).sort((a,b)=>b.revenue-a.revenue).slice(0,10);
  }, [orders]);

  // ── EXPORTS ───────────────────────────────────────────────────

  // GSTR-1 with state codes
  const exportGSTR1 = () => {
    const headers = ["Invoice No","Date","Customer","Platform","City","State Code","GST State Code","Taxable Amount","GST Rate%","CGST","SGST","IGST","Total Amount"];
    const rows = periodSales.map((s) => ({
      "Invoice No":     s.id,
      "Date":           s.date.toLocaleDateString("en-IN"),
      "Customer":       s.customer,
      "Platform":       s.platform.charAt(0).toUpperCase() + s.platform.slice(1),
      "City":           s.city,
      "State Code":     s.stateCode,
      "GST State Code": s.gstStateCode,
      "Taxable Amount": s.taxable,
      "GST Rate%":      s.gstRate,
      "CGST":           s.cgst,
      "SGST":           s.sgst,
      "IGST":           s.igst,
      "Total Amount":   s.total,
    }));
    // add totals row
    rows.push({
      "Invoice No": "TOTAL", "Date":"", "Customer":"", "Platform":"All", "City":"", "State Code":"", "GST State Code":"",
      "Taxable Amount": periodTotals.taxable,
      "GST Rate%": "",
      "CGST": periodTotals.cgst,
      "SGST": periodTotals.sgst,
      "IGST": periodTotals.igst,
      "Total Amount": periodTotals.total,
    });
    exportExcel(rows, headers, "GSTR1_" + MONTHS[month] + "_" + year);
    toast("GSTR-1 exported ✓", "success");
  };

  // State-wise summary export
  const exportStateWise = () => {
    const headers = ["State Code","GST State Code","No. of Orders","Taxable Amount","CGST","SGST","IGST","Total GST","Total Amount (incl. Tax)"];
    const rows = stateWise.map((s) => ({
      "State Code":                s.stateCode,
      "GST State Code":            s.gstCode,
      "No. of Orders":             s.orders,
      "Taxable Amount":            s.taxable,
      "CGST":                      s.cgst,
      "SGST":                      s.sgst,
      "IGST":                      s.igst,
      "Total GST":                 s.cgst + s.sgst + s.igst,
      "Total Amount (incl. Tax)":  s.total,
    }));
    rows.push({
      "State Code":"TOTAL", "GST State Code":"",
      "No. of Orders":            periodTotals.orders,
      "Taxable Amount":           periodTotals.taxable,
      "CGST":                     periodTotals.cgst,
      "SGST":                     periodTotals.sgst,
      "IGST":                     periodTotals.igst,
      "Total GST":                periodTotals.cgst+periodTotals.sgst+periodTotals.igst,
      "Total Amount (incl. Tax)": periodTotals.total,
    });
    exportExcel(rows, headers, "StatewiseSales_" + MONTHS[month] + "_" + year);
    toast("State-wise report exported ✓", "success");
  };

  // Consolidated all platforms
  const exportConsolidated = () => {
    const headers = ["Invoice No","Date","Platform","Customer","State Code","GST State Code","Taxable Amount","CGST","SGST","IGST","Total Amount"];
    const rows = allSales.map((s) => ({
      "Invoice No":     s.id,
      "Date":           s.date.toLocaleDateString("en-IN"),
      "Platform":       s.platform.charAt(0).toUpperCase() + s.platform.slice(1),
      "Customer":       s.customer,
      "State Code":     s.stateCode,
      "GST State Code": s.gstStateCode,
      "Taxable Amount": s.taxable,
      "CGST":           s.cgst,
      "SGST":           s.sgst,
      "IGST":           s.igst,
      "Total Amount":   s.total,
    }));
    rows.push({
      "Invoice No":"TOTAL","Date":"","Platform":"All Platforms","Customer":"",
      "State Code":"","GST State Code":"",
      "Taxable Amount": totals.taxable,
      "CGST": Math.round(totals.gst/2),
      "SGST": Math.round(totals.gst/2),
      "IGST": 0,
      "Total Amount": totals.revenue,
    });
    exportExcel(rows, headers, "Consolidated_AllPlatforms_" + year);
    toast("Consolidated report exported ✓", "success");
  };

  const exportAnalyticsCSV = () => {
    const headers = ["Product","Orders","Qty Sold","Revenue","Revenue Share%"];
    const rows = skuData.map((s) => ({
      "Product":        s.name,
      "Orders":         s.orders,
      "Qty Sold":       s.qty,
      "Revenue":        Math.round(s.revenue),
      "Revenue Share%": totals.revenue > 0 ? ((s.revenue/totals.revenue)*100).toFixed(1) : "0",
    }));
    exportExcel(rows, headers, "Analytics_SKU_" + year);
    toast("Analytics exported ✓", "success");
  };

  // ── AI GST Mismatch Detection ─────────────────────────────
  const addFilingRow = () => setFilingInput((prev) => [...prev, { month:"", taxableSales:0, cgst:0, sgst:0, igst:0, totalGst:0, platformSettlement:0 }]);
  const removeFilingRow = (i) => setFilingInput((prev) => prev.filter((_,idx)=>idx!==i));
  const updateFilingRow = (i, key, val) => setFilingInput((prev) => prev.map((r,idx)=>idx===i?{...r,[key]:val}:r));

  const handleStatementUpload = async (file) => {
    if (!file) return;
    try {
      const XLSX = await import("xlsx");
      const buf  = await file.arrayBuffer();
      const wb   = XLSX.read(buf);
      const ws   = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { defval: 0 });
      setUploadedStatement({ name: file.name, rows: rows.slice(0,24) });
      toast("Statement uploaded: " + rows.length + " rows ✓", "success");
    } catch(e) { toast("Failed to read file: "+e.message, "error"); }
  };

  const runGstAiAnalysis = async () => {
    setAiLoading(true);
    try {
      // Build platform data from orders/invoices
      const platformSales = {};
      orders.forEach((o) => {
        const date = new Date(o.created_at || o.date || Date.now());
        const key  = date.getFullYear()+"-"+String(date.getMonth()+1).padStart(2,"0");
        if (!platformSales[key]) platformSales[key] = { shopify:0, amazon:0, total:0, orders:0 };
        const val = parseFloat(o.total_price || 0);
        platformSales[key].shopify += val;
        platformSales[key].total   += val;
        platformSales[key].orders++;
      });

      // GST computed from our system
      const systemGst = {};
      allSales.forEach((s) => {
        const key = s.date?.slice(0,7) || "unknown";
        if (!systemGst[key]) systemGst[key] = { taxable:0, cgst:0, sgst:0, igst:0, total:0 };
        systemGst[key].taxable += s.taxable;
        systemGst[key].cgst    += s.cgst;
        systemGst[key].sgst    += s.sgst;
        systemGst[key].igst    += s.igst;
        systemGst[key].total   += s.gst;
      });

      const response = await fetch(PROXY + "/ai/anthropic-proxy", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + getToken() },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: 3000,
          messages: [{
            role: "user",
            content: `You are a GST compliance expert for an Indian ecommerce leather belts brand (Vasudeva Enterprises, GSTIN: 09BDOPB0236M2ZF, Ghaziabad UP).

Compare the GST data below and detect mismatches between:
1. Platform sales (what platforms reported)
2. System-calculated GST (what our invoicing system shows)
3. Manual GST filings entered by the user (what was actually filed with GST portal)

System-calculated GST by month:
${JSON.stringify(systemGst, null, 2)}

Platform sales by month:
${JSON.stringify(platformSales, null, 2)}

User's manual GST filing data (entered by user, may be partial):
${JSON.stringify(filingInput.filter((r)=>r.month), null, 2)}

Uploaded platform settlement data:
${uploadedStatement ? JSON.stringify(uploadedStatement.rows.slice(0,10), null, 2) : "Not provided"}

Analyse and return ONLY a JSON object (no markdown):
{
  "summary": {
    "totalSystemGst": number,
    "totalFiledGst": number,
    "totalMismatch": number,
    "riskLevel": "low|medium|high|critical",
    "complianceScore": number (0-100),
    "overview": "2-3 sentence summary"
  },
  "monthlyMismatches": [
    {
      "month": "YYYY-MM",
      "systemTaxable": number,
      "filedTaxable": number,
      "systemGst": number,
      "filedGst": number,
      "mismatchAmount": number,
      "mismatchType": "under_reported|over_reported|missing_filing|data_mismatch",
      "severity": "low|medium|high|critical",
      "explanation": "string"
    }
  ],
  "platformMismatches": [
    {
      "platform": "string",
      "issue": "string",
      "amount": number,
      "explanation": "string",
      "action": "string"
    }
  ],
  "recoveryOpportunities": [
    {
      "type": "string",
      "amount": number,
      "description": "string",
      "howToRecover": "string",
      "priority": "immediate|short_term|long_term"
    }
  ],
  "complianceIssues": [
    {
      "issue": "string",
      "severity": "low|medium|high",
      "penalty_risk": "string",
      "fix": "string"
    }
  ],
  "recommendations": [
    {
      "title": "string",
      "description": "string",
      "impact": "string"
    }
  ]
}`
          }]
        })
      });

      const data = await response.json();
      const text = data.content?.[0]?.text || "{}";
      const clean = text.replace(/```json|```/g, "").trim();
      setAiGst(JSON.parse(clean));
      toast("🤖 GST analysis complete", "success");
    } catch(e) { toast("Analysis failed: "+e.message, "error"); }
    setAiLoading(false);
  };

  return (
    <div>
      {/* main tabs */}
      <div style={{ display:"flex", borderBottom:"1px solid #e5e7eb", marginBottom:16 }}>
        {[{id:"analytics",label:"📊 Analytics"},{id:"gst",label:"📋 GST Reports"},{id:"statewise",label:"🗺 State-wise"},{id:"ai_gst",label:"🤖 AI Mismatch Detection"}].map((t)=>(
          <button key={t.id} style={S.tab(tab===t.id)} onClick={()=>setTab(t.id)}>{t.label}</button>
        ))}
        <div style={{ flex:1 }}/>
        <button style={{ ...S.btn("#2563eb"), margin:"6px 0", marginRight:8 }} onClick={exportConsolidated}>⬇ Consolidated Excel</button>
      </div>

      {/* ══ ANALYTICS ══ */}
      {tab==="analytics" && (
        <>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:14 }}>
            {[
              {label:"Total Revenue",     value:INR(Math.round(totals.revenue)), color:"#F47920"},
              {label:"Total GST Collected",value:INR(Math.round(totals.gst)),    color:"#2563eb"},
              {label:"Total Orders",       value:totals.orders,                  color:"#7c3aed"},
              {label:"Avg Order Value",    value:INR(Math.round(totals.avg)),    color:"#15803d"},
            ].map((k)=>(
              <div key={k.label} style={S.kpi}>
                <div style={{fontSize:11,color:"#6b7280",marginBottom:6}}>{k.label}</div>
                <div style={{fontSize:22,fontWeight:700,color:k.color}}>{k.value}</div>
              </div>
            ))}
          </div>

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
            <div style={S.card}>
              <div style={S.cardHdr}><span>Monthly Revenue (Last 6 months)</span><button style={S.btnOut} onClick={exportAnalyticsCSV}>⬇ CSV</button></div>
              <div style={{padding:"16px 20px"}}><BarChart data={monthlyData} color="#F47920" height={140}/></div>
            </div>
            <div style={S.card}>
              <div style={S.cardHdr}><span>Revenue by Platform</span></div>
              <div style={{padding:16}}>
                {platData.length===0
                  ? <div style={{textAlign:"center",padding:30,color:"#9ca3af",fontSize:13}}>No sales data yet</div>
                  : platData.map((p)=>(
                    <div key={p.id} style={{marginBottom:14}}>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:5,fontSize:13}}>
                        <span style={{fontWeight:500,color:p.color}}>{p.name}</span>
                        <span style={{fontWeight:600}}>{INR(Math.round(p.revenue))} <span style={{color:"#9ca3af",fontWeight:400}}>({PCT(p.pct)})</span></span>
                      </div>
                      <div style={{height:6,background:"#f3f4f6",borderRadius:3}}>
                        <div style={{height:6,background:p.color,borderRadius:3,width:PCT(p.pct),opacity:0.85}}/>
                      </div>
                      <div style={{fontSize:11,color:"#9ca3af",marginTop:3}}>{p.orders} orders</div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div style={S.card}>
            <div style={S.cardHdr}><span>Top Products by Revenue</span><button style={S.btnOut} onClick={exportAnalyticsCSV}>⬇ CSV</button></div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr>
                  <th style={S.th}>#</th><th style={S.th}>Product</th>
                  <th style={S.thR}>Orders</th><th style={S.thR}>Qty Sold</th>
                  <th style={S.thR}>Revenue</th><th style={S.thR}>Share</th>
                </tr></thead>
                <tbody>
                  {skuData.length===0
                    ? <tr><td colSpan={6} style={{...S.td,textAlign:"center",color:"#9ca3af",padding:40}}>No product data — sync orders first</td></tr>
                    : skuData.map((s,i)=>(
                      <tr key={i} onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"} onMouseLeave={(e)=>e.currentTarget.style.background=""}>
                        <td style={{...S.td,color:"#9ca3af",fontWeight:600}}>{i+1}</td>
                        <td style={{...S.td,fontWeight:500}}>{s.name}</td>
                        <td style={S.tdR}>{s.orders}</td>
                        <td style={S.tdR}>{s.qty}</td>
                        <td style={{...S.tdR,fontWeight:700,color:"#F47920"}}>{INR(Math.round(s.revenue))}</td>
                        <td style={S.tdR}>
                          <div style={{display:"flex",alignItems:"center",gap:8,justifyContent:"flex-end"}}>
                            <div style={{width:60,height:6,background:"#f3f4f6",borderRadius:3}}>
                              <div style={{height:6,background:"#F47920",borderRadius:3,width:PCT(totals.revenue>0?(s.revenue/totals.revenue)*100:0),opacity:0.8}}/>
                            </div>
                            <span style={{fontSize:11,color:"#6b7280"}}>{PCT(totals.revenue>0?(s.revenue/totals.revenue)*100:0)}</span>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div style={S.card}>
            <div style={S.cardHdr}><span>Channel-wise Performance</span></div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr>
                  <th style={S.th}>Platform</th><th style={S.thR}>Orders</th>
                  <th style={S.thR}>Revenue</th><th style={S.thR}>Avg Order</th>
                  <th style={S.thR}>GST Collected</th><th style={S.thR}>Share</th>
                </tr></thead>
                <tbody>
                  {PLATFORMS.map((pl)=>{
                    const sales=allSales.filter((s)=>s.platform===pl.id);
                    const rev=sales.reduce((a,s)=>a+s.total,0);
                    const gst=sales.reduce((a,s)=>a+s.gst,0);
                    const avg=sales.length>0?rev/sales.length:0;
                    const pct=totals.revenue>0?(rev/totals.revenue)*100:0;
                    return (
                      <tr key={pl.id} onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"} onMouseLeave={(e)=>e.currentTarget.style.background=""}>
                        <td style={S.td}><span style={{fontWeight:600,color:pl.color}}>{pl.name}</span></td>
                        <td style={S.tdR}>{sales.length}</td>
                        <td style={{...S.tdR,fontWeight:600}}>{INR(Math.round(rev))}</td>
                        <td style={S.tdR}>{INR(Math.round(avg))}</td>
                        <td style={{...S.tdR,color:"#2563eb"}}>{INR(Math.round(gst))}</td>
                        <td style={S.tdR}><Badge label={PCT(pct)} color={pct>30?"#15803d":"#6b7280"} bg={pct>30?"#f0fdf4":"#f3f4f6"}/></td>
                      </tr>
                    );
                  })}
                  <tr style={{background:"#f9fafb",fontWeight:700}}>
                    <td style={S.td}>Total</td>
                    <td style={S.tdR}>{totals.orders}</td>
                    <td style={{...S.tdR,color:"#F47920"}}>{INR(Math.round(totals.revenue))}</td>
                    <td style={S.tdR}>{INR(Math.round(totals.avg))}</td>
                    <td style={{...S.tdR,color:"#2563eb"}}>{INR(Math.round(totals.gst))}</td>
                    <td style={S.tdR}>100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {/* ══ GST REPORTS ══ */}
      {tab==="gst" && (
        <>
          {/* period + platform filters */}
          <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:14,background:"#fff",padding:"12px 16px",borderRadius:10,border:"1px solid #e5e7eb",flexWrap:"wrap"}}>
            <span style={{fontSize:13,fontWeight:600,color:"#374151"}}>Period:</span>
            <select style={S.sel} value={month} onChange={(e)=>setMonth(parseInt(e.target.value))}>
              {MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}
            </select>
            <select style={S.sel} value={year} onChange={(e)=>setYear(parseInt(e.target.value))}>
              {years.map((y)=><option key={y} value={y}>{y}</option>)}
            </select>
            <select style={S.sel} value={platFilter} onChange={(e)=>setPlatFilter(e.target.value)}>
              <option value="all">All Platforms</option>
              {PLATFORMS.map((p)=><option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
            <span style={{fontSize:12,color:"#9ca3af"}}>{periodSales.length} transactions</span>
            <div style={{flex:1}}/>
            <button style={S.btnOut} onClick={()=>window.print()}>🖨 Print</button>
            <button style={S.btn()} onClick={exportGSTR1}>⬇ Export GSTR-1</button>
          </div>

          {/* period KPIs */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,marginBottom:14}}>
            {[
              {label:"Total Amount",      value:INR(periodTotals.total),   color:"#F47920"},
              {label:"Taxable Value",     value:INR(periodTotals.taxable), color:"#374151"},
              {label:"CGST (9%)",         value:INR(periodTotals.cgst),    color:"#2563eb"},
              {label:"SGST (9%)",         value:INR(periodTotals.sgst),    color:"#7c3aed"},
              {label:"Total GST",         value:INR(periodTotals.cgst+periodTotals.sgst), color:"#dc2626"},
            ].map((k)=>(
              <div key={k.label} style={S.kpi}>
                <div style={{fontSize:11,color:"#6b7280",marginBottom:6}}>{k.label}</div>
                <div style={{fontSize:18,fontWeight:700,color:k.color}}>{k.value}</div>
                <div style={{fontSize:10,color:"#9ca3af",marginTop:3}}>{MONTHS[month]} {year}</div>
              </div>
            ))}
          </div>

          {/* GST sub tabs */}
          <div style={{display:"flex",borderBottom:"1px solid #e5e7eb",marginBottom:14}}>
            {[{id:"gstr1",label:"GSTR-1 (Invoice-wise)"},{id:"gstr3b",label:"GSTR-3B (Summary)"}].map((t)=>(
              <button key={t.id} style={S.tab(gstTab===t.id)} onClick={()=>setGstTab(t.id)}>{t.label}</button>
            ))}
          </div>

          {/* GSTR-1 table */}
          {gstTab==="gstr1" && (
            <div style={S.card}>
              <div style={S.cardHdr}>
                <span>GSTR-1 — {MONTHS[month]} {year}</span>
                <span style={{fontSize:12,color:"#9ca3af"}}>{periodSales.length} invoices</span>
              </div>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr>
                    <th style={S.th}>Invoice No</th><th style={S.th}>Date</th>
                    <th style={S.th}>Customer</th><th style={S.th}>Platform</th>
                    <th style={S.th}>State</th><th style={S.th}>GST Code</th>
                    <th style={S.thR}>Taxable</th><th style={S.thR}>CGST</th>
                    <th style={S.thR}>SGST</th><th style={S.thR}>Total</th>
                  </tr></thead>
                  <tbody>
                    {periodSales.length===0
                      ? <tr><td colSpan={10} style={{...S.td,textAlign:"center",color:"#9ca3af",padding:40}}>No transactions for {MONTHS[month]} {year}</td></tr>
                      : periodSales.map((s,i)=>{
                        const pl=PLATFORMS.find((p)=>p.id===s.platform)||{color:"#6b7280"};
                        return (
                          <tr key={i} onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"} onMouseLeave={(e)=>e.currentTarget.style.background=""}>
                            <td style={{...S.td,fontFamily:"monospace",fontSize:11,color:"#2563eb"}}>{s.id}</td>
                            <td style={{...S.td,fontSize:11,color:"#6b7280"}}>{s.date.toLocaleDateString("en-IN")}</td>
                            <td style={S.td}>{s.customer}</td>
                            <td style={S.td}><span style={{fontWeight:600,color:pl.color,fontSize:11}}>{s.platform}</span></td>
                            <td style={S.td}><Badge label={s.stateCode} color="#374151" bg="#f3f4f6"/></td>
                            <td style={S.td}><Badge label={s.gstStateCode||"00"} color="#2563eb" bg="#eff6ff"/></td>
                            <td style={S.tdR}>{INR(s.taxable)}</td>
                            <td style={{...S.tdR,color:"#2563eb"}}>{INR(s.cgst)}</td>
                            <td style={{...S.tdR,color:"#7c3aed"}}>{INR(s.sgst)}</td>
                            <td style={{...S.tdR,fontWeight:700,color:"#F47920"}}>{INR(s.total)}</td>
                          </tr>
                        );
                      })}
                    {periodSales.length>0 && (
                      <tr style={{background:"#f9fafb",fontWeight:700}}>
                        <td style={S.td} colSpan={6}>Total ({periodSales.length} invoices)</td>
                        <td style={S.tdR}>{INR(periodTotals.taxable)}</td>
                        <td style={{...S.tdR,color:"#2563eb"}}>{INR(periodTotals.cgst)}</td>
                        <td style={{...S.tdR,color:"#7c3aed"}}>{INR(periodTotals.sgst)}</td>
                        <td style={{...S.tdR,color:"#F47920"}}>{INR(periodTotals.total)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* GSTR-3B */}
          {gstTab==="gstr3b" && (
            <div style={S.card}>
              <div style={S.cardHdr}><span>GSTR-3B Summary · {MONTHS[month]} {year}</span></div>
              <div style={{padding:16}}>
                <div style={{fontWeight:600,fontSize:13,marginBottom:12}}>3.1 Outward Supplies</div>
                <div style={{overflowX:"auto",marginBottom:20}}>
                  <table style={{width:"100%",borderCollapse:"collapse"}}>
                    <thead><tr>
                      <th style={S.th}>Nature</th><th style={S.thR}>Taxable Value</th>
                      <th style={S.thR}>IGST</th><th style={S.thR}>CGST</th>
                      <th style={S.thR}>SGST</th><th style={S.thR}>CESS</th>
                    </tr></thead>
                    <tbody>
                      {[
                        ["Outward taxable supplies", periodTotals.taxable, 0, periodTotals.cgst, periodTotals.sgst],
                        ["Zero rated supply", 0, 0, 0, 0],
                      ].map(([label,tax,igst,cgst,sgst],i)=>(
                        <tr key={i} onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"} onMouseLeave={(e)=>e.currentTarget.style.background=""}>
                          <td style={S.td}>{label}</td>
                          <td style={S.tdR}>{INR(tax)}</td>
                          <td style={S.tdR}>{INR(igst)}</td>
                          <td style={{...S.tdR,color:"#2563eb"}}>{INR(cgst)}</td>
                          <td style={{...S.tdR,color:"#7c3aed"}}>{INR(sgst)}</td>
                          <td style={S.tdR}>0</td>
                        </tr>
                      ))}
                      <tr style={{background:"#f9fafb",fontWeight:700}}>
                        <td style={S.td}>Total</td>
                        <td style={S.tdR}>{INR(periodTotals.taxable)}</td>
                        <td style={S.tdR}>0</td>
                        <td style={{...S.tdR,color:"#2563eb"}}>{INR(periodTotals.cgst)}</td>
                        <td style={{...S.tdR,color:"#7c3aed"}}>{INR(periodTotals.sgst)}</td>
                        <td style={S.tdR}>0</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style={{background:"#f9fafb",borderRadius:8,padding:14}}>
                  <div style={{fontWeight:600,fontSize:13,marginBottom:8}}>4. Eligible ITC</div>
                  <div style={{fontSize:13,color:"#6b7280"}}>Connect accounting system to auto-populate ITC.</div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* ══ STATE-WISE REPORT ══ */}
      {tab==="statewise" && (
        <>
          <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:14,background:"#fff",padding:"12px 16px",borderRadius:10,border:"1px solid #e5e7eb",flexWrap:"wrap"}}>
            <span style={{fontSize:13,fontWeight:600,color:"#374151"}}>Period:</span>
            <select style={S.sel} value={month} onChange={(e)=>setMonth(parseInt(e.target.value))}>
              {MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}
            </select>
            <select style={S.sel} value={year} onChange={(e)=>setYear(parseInt(e.target.value))}>
              {years.map((y)=><option key={y} value={y}>{y}</option>)}
            </select>
            <select style={S.sel} value={platFilter} onChange={(e)=>setPlatFilter(e.target.value)}>
              <option value="all">All Platforms (Consolidated)</option>
              {PLATFORMS.map((p)=><option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
            <span style={{fontSize:12,color:"#9ca3af"}}>{stateWise.length} states · {periodTotals.orders} orders</span>
            <div style={{flex:1}}/>
            <button style={S.btnOut} onClick={()=>window.print()}>🖨 Print</button>
            <button style={S.btn()} onClick={exportStateWise}>⬇ Export Excel</button>
          </div>

          {/* state KPIs */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
            {[
              {label:"States Covered",    value:stateWise.length,              color:"#2563eb"},
              {label:"Total Orders",      value:periodTotals.orders,           color:"#7c3aed"},
              {label:"Taxable Amount",    value:INR(periodTotals.taxable),     color:"#374151"},
              {label:"Total Tax",         value:INR(periodTotals.cgst+periodTotals.sgst), color:"#F47920"},
            ].map((k)=>(
              <div key={k.label} style={S.kpi}>
                <div style={{fontSize:11,color:"#6b7280",marginBottom:6}}>{k.label}</div>
                <div style={{fontSize:22,fontWeight:700,color:k.color}}>{k.value}</div>
              </div>
            ))}
          </div>

          <div style={S.card}>
            <div style={S.cardHdr}>
              <span>State-wise Sales Summary · {MONTHS[month]} {year} · {platFilter==="all"?"All Platforms":PLATFORMS.find((p)=>p.id===platFilter)?.name}</span>
              <span style={{fontSize:12,color:"#9ca3af"}}>{stateWise.length} states</span>
            </div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr>
                  <th style={S.th}>#</th>
                  <th style={S.th}>State Code</th>
                  <th style={S.th}>GST State Code</th>
                  <th style={S.thR}>No. of Orders</th>
                  <th style={S.thR}>Amount Before Tax</th>
                  <th style={S.thR}>CGST</th>
                  <th style={S.thR}>SGST</th>
                  <th style={S.thR}>IGST</th>
                  <th style={S.thR}>Total Tax</th>
                  <th style={S.thR}>Total Amount (incl. Tax)</th>
                </tr></thead>
                <tbody>
                  {stateWise.length===0
                    ? <tr><td colSpan={10} style={{...S.td,textAlign:"center",color:"#9ca3af",padding:40}}>No data for selected period and platform</td></tr>
                    : stateWise.map((s,i)=>(
                      <tr key={i} onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"} onMouseLeave={(e)=>e.currentTarget.style.background=""}>
                        <td style={{...S.td,color:"#9ca3af",fontWeight:600}}>{i+1}</td>
                        <td style={S.td}><Badge label={s.stateCode} color="#374151" bg="#f3f4f6"/></td>
                        <td style={S.td}><Badge label={s.gstCode||"00"} color="#2563eb" bg="#eff6ff"/></td>
                        <td style={S.tdR}>{s.orders}</td>
                        <td style={S.tdR}>{INR(s.taxable)}</td>
                        <td style={{...S.tdR,color:"#2563eb"}}>{INR(s.cgst)}</td>
                        <td style={{...S.tdR,color:"#7c3aed"}}>{INR(s.sgst)}</td>
                        <td style={S.tdR}>{INR(s.igst)}</td>
                        <td style={{...S.tdR,color:"#dc2626",fontWeight:600}}>{INR(s.cgst+s.sgst+s.igst)}</td>
                        <td style={{...S.tdR,fontWeight:700,color:"#F47920"}}>{INR(s.total)}</td>
                      </tr>
                    ))}
                  {stateWise.length>0 && (
                    <tr style={{background:"#f9fafb",fontWeight:700}}>
                      <td style={S.td} colSpan={3}>Grand Total</td>
                      <td style={S.tdR}>{periodTotals.orders}</td>
                      <td style={S.tdR}>{INR(periodTotals.taxable)}</td>
                      <td style={{...S.tdR,color:"#2563eb"}}>{INR(periodTotals.cgst)}</td>
                      <td style={{...S.tdR,color:"#7c3aed"}}>{INR(periodTotals.sgst)}</td>
                      <td style={S.tdR}>{INR(periodTotals.igst)}</td>
                      <td style={{...S.tdR,color:"#dc2626"}}>{INR(periodTotals.cgst+periodTotals.sgst+periodTotals.igst)}</td>
                      <td style={{...S.tdR,color:"#F47920"}}>{INR(periodTotals.total)}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {/* ══ AI GST MISMATCH DETECTION ══ */}
      {tab === "ai_gst" && (
        <div>
          {/* Input section */}
          <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
            <div style={{ padding:"12px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13 }}>
              📂 Step 1 — Enter Your Filed GST Returns (Optional but improves accuracy)
            </div>
            <div style={{ padding:16 }}>
              <div style={{ fontSize:12, color:"#6b7280", marginBottom:12 }}>
                Enter the GST amounts you actually filed on the GST portal each month. Leave blank if not filed yet — AI will still detect mismatches from platform data.
              </div>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                  <thead><tr>
                    {["Month (YYYY-MM)","Taxable Sales (₹)","CGST (₹)","SGST (₹)","IGST (₹)","Total GST Filed (₹)","Platform Settlement (₹)",""].map((h)=>(
                      <th key={h} style={{ ...S.th, whiteSpace:"nowrap" }}>{h}</th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {filingInput.map((row, i) => (
                      <tr key={i}>
                        {[
                          ["month","text","e.g. 2026-03"],
                          ["taxableSales","number","0"],
                          ["cgst","number","0"],
                          ["sgst","number","0"],
                          ["igst","number","0"],
                          ["totalGst","number","0"],
                          ["platformSettlement","number","0"],
                        ].map(([key, type, ph]) => (
                          <td key={key} style={S.td}>
                            <input type={type} placeholder={ph}
                              style={{ width:"100%", padding:"5px 8px", borderRadius:6, border:"1px solid #d1d5db", fontSize:11, fontFamily:"inherit", outline:"none" }}
                              value={row[key]} onChange={(e)=>updateFilingRow(i,key,type==="number"?parseFloat(e.target.value)||0:e.target.value)}/>
                          </td>
                        ))}
                        <td style={S.td}>
                          <button onClick={()=>removeFilingRow(i)} style={{ background:"none", border:"none", color:"#dc2626", cursor:"pointer", fontSize:16 }}>×</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button style={{ ...S.btnOut, marginTop:10, fontSize:12 }} onClick={addFilingRow}>+ Add Month</button>
            </div>
          </div>

          {/* Statement upload */}
          <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
            <div style={{ padding:"12px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13 }}>
              📊 Step 2 — Upload Platform Settlement Statement (Optional)
            </div>
            <div style={{ padding:16, display:"flex", alignItems:"center", gap:14, flexWrap:"wrap" }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, color:"#6b7280", marginBottom:6 }}>Upload Amazon/Flipkart/Shopify settlement Excel for more accurate comparison</div>
                {uploadedStatement && <div style={{ fontSize:11, color:"#15803d", fontWeight:600 }}>✅ {uploadedStatement.name} — {uploadedStatement.rows.length} rows loaded</div>}
              </div>
              <label style={{ ...S.btn("#6366f1"), cursor:"pointer", fontSize:12 }}>
                ⬆ Upload Settlement Excel
                <input type="file" accept=".xlsx,.xls,.csv" style={{ display:"none" }} onChange={(e)=>handleStatementUpload(e.target.files[0])}/>
              </label>
            </div>
          </div>

          {/* Run Analysis */}
          <div style={{ textAlign:"center", marginBottom:20 }}>
            <button style={{ ...S.btn("#6366f1"), padding:"12px 32px", fontSize:14, opacity:aiLoading?0.7:1 }} onClick={runGstAiAnalysis} disabled={aiLoading}>
              {aiLoading ? "🤖 Analysing GST data…" : "🤖 Run AI GST Mismatch Detection"}
            </button>
            <div style={{ fontSize:11, color:"#9ca3af", marginTop:8 }}>
              AI compares platform sales, your invoices and filed returns to find discrepancies
            </div>
          </div>

          {/* Results */}
          {aiLoading && (
            <div style={{ background:"#fff", borderRadius:10, border:"2px solid #6366f1", padding:60, textAlign:"center" }}>
              <div style={{ fontSize:48, marginBottom:12 }}>🔍</div>
              <div style={{ fontWeight:700, fontSize:16, color:"#6366f1" }}>Analysing GST data…</div>
              <div style={{ fontSize:12, color:"#9ca3af", marginTop:6 }}>Comparing platform sales, invoices and filed returns</div>
            </div>
          )}

          {!aiLoading && aiGst && (() => {
            const riskColors = { low:["#15803d","#f0fdf4"], medium:["#d97706","#fffbeb"], high:["#dc2626","#fef2f2"], critical:["#7c2d12","#fef2f2"] };
            const sevColors  = riskColors;
            const priColors  = { immediate:["#dc2626","#fef2f2"], short_term:["#d97706","#fffbeb"], long_term:["#15803d","#f0fdf4"] };
            const [rc,rbg]   = riskColors[aiGst.summary?.riskLevel]||riskColors.medium;
            const mismatch   = aiGst.summary?.totalMismatch || 0;
            const score      = aiGst.summary?.complianceScore || 0;

            return (
              <div>
                <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:10 }}>
                  <button style={{ ...S.btn("#6366f1"), fontSize:12 }} onClick={runGstAiAnalysis}>↻ Re-analyse</button>
                </div>

                {/* Summary banner */}
                <div style={{ background:"linear-gradient(135deg,#1A3A5C,#2563eb)", borderRadius:10, padding:"18px 20px", marginBottom:14, color:"#fff" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12 }}>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700, fontSize:16, marginBottom:6 }}>🤖 AI GST Mismatch Detection Report</div>
                      <div style={{ fontSize:13, opacity:.9, lineHeight:1.5 }}>{aiGst.summary?.overview}</div>
                    </div>
                    <div style={{ display:"flex", gap:10, flexWrap:"wrap", flexShrink:0 }}>
                      {[
                        ["System GST",  "₹"+(aiGst.summary?.totalSystemGst||0).toLocaleString("en-IN")],
                        ["Filed GST",   "₹"+(aiGst.summary?.totalFiledGst||0).toLocaleString("en-IN")],
                        ["Mismatch",    "₹"+Math.abs(mismatch).toLocaleString("en-IN")],
                      ].map(([l,v])=>(
                        <div key={l} style={{ background:"rgba(255,255,255,0.15)", borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                          <div style={{ fontSize:9, opacity:.8, textTransform:"uppercase", marginBottom:3 }}>{l}</div>
                          <div style={{ fontWeight:700, fontSize:14 }}>{v}</div>
                        </div>
                      ))}
                      <div style={{ background:"#fff", borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                        <div style={{ fontSize:9, color:"#6b7280", textTransform:"uppercase", marginBottom:3 }}>Compliance Score</div>
                        <div style={{ fontWeight:800, fontSize:20, color:score>=80?"#15803d":score>=60?"#d97706":"#dc2626" }}>{score}/100</div>
                      </div>
                      <div style={{ background:rbg, borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                        <div style={{ fontSize:9, color:rc, textTransform:"uppercase", marginBottom:3 }}>Risk</div>
                        <div style={{ fontWeight:700, fontSize:13, color:rc }}>{aiGst.summary?.riskLevel?.toUpperCase()}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Monthly Mismatches table */}
                {(aiGst.monthlyMismatches||[]).length > 0 && (
                  <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
                    <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#dc2626" }}>
                      📅 Monthly GST Mismatches
                    </div>
                    <div style={{ overflowX:"auto" }}>
                      <table style={{ width:"100%", borderCollapse:"collapse" }}>
                        <thead><tr>
                          {["Month","System Taxable","Filed Taxable","System GST","Filed GST","Mismatch","Type","Severity","Explanation"].map((h)=>(
                            <th key={h} style={{ ...S.th, whiteSpace:"nowrap" }}>{h}</th>
                          ))}
                        </tr></thead>
                        <tbody>
                          {(aiGst.monthlyMismatches||[]).map((m,i)=>{
                            const [sc,sbg] = sevColors[m.severity]||sevColors.medium;
                            const isUnder = m.mismatchType==="under_reported"||m.mismatchType==="missing_filing";
                            return (
                              <tr key={i} style={{ background:m.severity==="critical"?"#fef2f2":m.severity==="high"?"#fff7ed":"" }}
                                onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"}
                                onMouseLeave={(e)=>e.currentTarget.style.background=m.severity==="critical"?"#fef2f2":m.severity==="high"?"#fff7ed":""}>
                                <td style={{ ...S.td, fontWeight:600 }}>{m.month}</td>
                                <td style={S.td}>{INR(m.systemTaxable)}</td>
                                <td style={S.td}>{INR(m.filedTaxable)}</td>
                                <td style={{ ...S.td, color:"#2563eb", fontWeight:600 }}>{INR(m.systemGst)}</td>
                                <td style={S.td}>{INR(m.filedGst)}</td>
                                <td style={{ ...S.td, fontWeight:700, color:isUnder?"#dc2626":"#15803d" }}>
                                  {isUnder?"▼":"▲"} {INR(Math.abs(m.mismatchAmount))}
                                </td>
                                <td style={S.td}>
                                  <span style={{ background:isUnder?"#fef2f2":"#f0fdf4", color:isUnder?"#dc2626":"#15803d", padding:"2px 8px", borderRadius:10, fontSize:10, fontWeight:700 }}>
                                    {m.mismatchType?.replace(/_/g," ")}
                                  </span>
                                </td>
                                <td style={S.td}>
                                  <span style={{ background:sbg, color:sc, padding:"2px 8px", borderRadius:10, fontSize:10, fontWeight:700 }}>{m.severity}</span>
                                </td>
                                <td style={{ ...S.td, fontSize:11, color:"#6b7280", maxWidth:200, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{m.explanation}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr style={{ background:"#f9fafb", fontWeight:700 }}>
                            <td style={S.td} colSpan={5}>Total Mismatch</td>
                            <td style={{ ...S.td, fontSize:14, color:mismatch>0?"#dc2626":"#15803d", fontWeight:800 }}>
                              {mismatch>0?"▼":"▲"} {INR(Math.abs(mismatch))}
                            </td>
                            <td colSpan={3} style={S.td}/>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}

                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:14 }}>
                  {/* Platform Mismatches */}
                  {(aiGst.platformMismatches||[]).length > 0 && (
                    <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb" }}>
                      <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#d97706" }}>
                        🛒 Platform-wise Discrepancies
                      </div>
                      <div style={{ padding:14 }}>
                        {(aiGst.platformMismatches||[]).map((p,i)=>(
                          <div key={i} style={{ borderBottom:"1px solid #f3f4f6", paddingBottom:12, marginBottom:12 }}>
                            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                              <span style={{ fontWeight:700, fontSize:13 }}>{p.platform}</span>
                              <span style={{ fontWeight:700, color:"#dc2626" }}>{INR(p.amount)}</span>
                            </div>
                            <div style={{ fontSize:11, color:"#6b7280", marginBottom:4 }}>{p.explanation}</div>
                            <div style={{ background:"#fffbeb", borderRadius:5, padding:"5px 8px", fontSize:11, color:"#92400e" }}>💡 {p.action}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Recovery Opportunities */}
                  {(aiGst.recoveryOpportunities||[]).length > 0 && (
                    <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb" }}>
                      <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#15803d" }}>
                        💰 Recovery Opportunities
                      </div>
                      <div style={{ padding:14 }}>
                        {(aiGst.recoveryOpportunities||[]).map((r,i)=>{
                          const [pc,pbg] = priColors[r.priority]||priColors.short_term;
                          return (
                            <div key={i} style={{ borderBottom:"1px solid #f3f4f6", paddingBottom:12, marginBottom:12, borderLeft:`3px solid ${pc}`, paddingLeft:10 }}>
                              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                                <span style={{ fontWeight:700, fontSize:12 }}>{r.type}</span>
                                <span style={{ fontWeight:800, color:"#15803d", fontSize:14 }}>₹{(r.amount||0).toLocaleString("en-IN")}</span>
                              </div>
                              <div style={{ fontSize:11, color:"#6b7280", marginBottom:4 }}>{r.description}</div>
                              <div style={{ fontSize:11, color:"#15803d" }}>👉 {r.howToRecover}</div>
                            </div>
                          );
                        })}
                        <div style={{ background:"#f0fdf4", borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                          <div style={{ fontSize:11, color:"#6b7280" }}>Total Recoverable</div>
                          <div style={{ fontSize:20, fontWeight:800, color:"#15803d" }}>
                            {INR((aiGst.recoveryOpportunities||[]).reduce((a,r)=>a+(r.amount||0),0))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Compliance Issues */}
                {(aiGst.complianceIssues||[]).length > 0 && (
                  <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
                    <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#dc2626" }}>
                      ⚠️ Compliance Issues & Penalty Risks
                    </div>
                    <div style={{ padding:14, display:"flex", flexDirection:"column", gap:10 }}>
                      {(aiGst.complianceIssues||[]).map((c,i)=>{
                        const [ic,ibg] = riskColors[c.severity]||riskColors.medium;
                        return (
                          <div key={i} style={{ display:"flex", gap:12, padding:"10px 14px", background:"#f9fafb", borderRadius:8, borderLeft:`4px solid ${ic}` }}>
                            <span style={{ background:ibg, color:ic, padding:"2px 8px", borderRadius:10, fontSize:10, fontWeight:700, height:"fit-content", whiteSpace:"nowrap" }}>{c.severity}</span>
                            <div style={{ flex:1 }}>
                              <div style={{ fontWeight:700, fontSize:12, marginBottom:3 }}>{c.issue}</div>
                              <div style={{ fontSize:11, color:"#dc2626", marginBottom:3 }}>⚠ Penalty risk: {c.penalty_risk}</div>
                              <div style={{ fontSize:11, color:"#15803d" }}>✅ Fix: {c.fix}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Recommendations */}
                {(aiGst.recommendations||[]).length > 0 && (
                  <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb" }}>
                    <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13 }}>
                      ✅ AI Recommendations
                    </div>
                    <div style={{ padding:14, display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:10 }}>
                      {(aiGst.recommendations||[]).map((r,i)=>(
                        <div key={i} style={{ background:"#f9fafb", borderRadius:8, padding:"12px 14px", borderTop:"3px solid #6366f1" }}>
                          <div style={{ fontWeight:700, fontSize:12, marginBottom:4, color:"#1A3A5C" }}>{r.title}</div>
                          <div style={{ fontSize:11, color:"#6b7280", marginBottom:6 }}>{r.description}</div>
                          <div style={{ fontSize:11, color:"#6366f1", fontWeight:600 }}>📈 {r.impact}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}

      {/* ══ AI GST MISMATCH DETECTION ══ */}
      {tab === "ai_gst" && (
        <div>
          {/* Input section */}
          <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
            <div style={{ padding:"12px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13 }}>
              📂 Step 1 — Enter Your Filed GST Returns (Optional but improves accuracy)
            </div>
            <div style={{ padding:16 }}>
              <div style={{ fontSize:12, color:"#6b7280", marginBottom:12 }}>
                Enter the GST amounts you actually filed on the GST portal each month. Leave blank if not filed yet — AI will still detect mismatches from platform data.
              </div>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                  <thead><tr>
                    {["Month (YYYY-MM)","Taxable Sales (₹)","CGST (₹)","SGST (₹)","IGST (₹)","Total GST Filed (₹)","Platform Settlement (₹)",""].map((h)=>(
                      <th key={h} style={{ ...S.th, whiteSpace:"nowrap" }}>{h}</th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {filingInput.map((row, i) => (
                      <tr key={i}>
                        {[
                          ["month","text","e.g. 2026-03"],
                          ["taxableSales","number","0"],
                          ["cgst","number","0"],
                          ["sgst","number","0"],
                          ["igst","number","0"],
                          ["totalGst","number","0"],
                          ["platformSettlement","number","0"],
                        ].map(([key, type, ph]) => (
                          <td key={key} style={S.td}>
                            <input type={type} placeholder={ph}
                              style={{ width:"100%", padding:"5px 8px", borderRadius:6, border:"1px solid #d1d5db", fontSize:11, fontFamily:"inherit", outline:"none" }}
                              value={row[key]} onChange={(e)=>updateFilingRow(i,key,type==="number"?parseFloat(e.target.value)||0:e.target.value)}/>
                          </td>
                        ))}
                        <td style={S.td}>
                          <button onClick={()=>removeFilingRow(i)} style={{ background:"none", border:"none", color:"#dc2626", cursor:"pointer", fontSize:16 }}>×</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button style={{ ...S.btnOut, marginTop:10, fontSize:12 }} onClick={addFilingRow}>+ Add Month</button>
            </div>
          </div>

          {/* Statement upload */}
          <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
            <div style={{ padding:"12px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13 }}>
              📊 Step 2 — Upload Platform Settlement Statement (Optional)
            </div>
            <div style={{ padding:16, display:"flex", alignItems:"center", gap:14, flexWrap:"wrap" }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, color:"#6b7280", marginBottom:6 }}>Upload Amazon/Flipkart/Shopify settlement Excel for more accurate comparison</div>
                {uploadedStatement && <div style={{ fontSize:11, color:"#15803d", fontWeight:600 }}>✅ {uploadedStatement.name} — {uploadedStatement.rows.length} rows loaded</div>}
              </div>
              <label style={{ ...S.btn("#6366f1"), cursor:"pointer", fontSize:12 }}>
                ⬆ Upload Settlement Excel
                <input type="file" accept=".xlsx,.xls,.csv" style={{ display:"none" }} onChange={(e)=>handleStatementUpload(e.target.files[0])}/>
              </label>
            </div>
          </div>

          {/* Run Analysis */}
          <div style={{ textAlign:"center", marginBottom:20 }}>
            <button style={{ ...S.btn("#6366f1"), padding:"12px 32px", fontSize:14, opacity:aiLoading?0.7:1 }} onClick={runGstAiAnalysis} disabled={aiLoading}>
              {aiLoading ? "🤖 Analysing GST data…" : "🤖 Run AI GST Mismatch Detection"}
            </button>
            <div style={{ fontSize:11, color:"#9ca3af", marginTop:8 }}>
              AI compares platform sales, your invoices and filed returns to find discrepancies
            </div>
          </div>

          {/* Results */}
          {aiLoading && (
            <div style={{ background:"#fff", borderRadius:10, border:"2px solid #6366f1", padding:60, textAlign:"center" }}>
              <div style={{ fontSize:48, marginBottom:12 }}>🔍</div>
              <div style={{ fontWeight:700, fontSize:16, color:"#6366f1" }}>Analysing GST data…</div>
              <div style={{ fontSize:12, color:"#9ca3af", marginTop:6 }}>Comparing platform sales, invoices and filed returns</div>
            </div>
          )}

          {!aiLoading && aiGst && (() => {
            const riskColors = { low:["#15803d","#f0fdf4"], medium:["#d97706","#fffbeb"], high:["#dc2626","#fef2f2"], critical:["#7c2d12","#fef2f2"] };
            const sevColors  = riskColors;
            const priColors  = { immediate:["#dc2626","#fef2f2"], short_term:["#d97706","#fffbeb"], long_term:["#15803d","#f0fdf4"] };
            const [rc,rbg]   = riskColors[aiGst.summary?.riskLevel]||riskColors.medium;
            const mismatch   = aiGst.summary?.totalMismatch || 0;
            const score      = aiGst.summary?.complianceScore || 0;

            return (
              <div>
                <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:10 }}>
                  <button style={{ ...S.btn("#6366f1"), fontSize:12 }} onClick={runGstAiAnalysis}>↻ Re-analyse</button>
                </div>

                {/* Summary banner */}
                <div style={{ background:"linear-gradient(135deg,#1A3A5C,#2563eb)", borderRadius:10, padding:"18px 20px", marginBottom:14, color:"#fff" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12 }}>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700, fontSize:16, marginBottom:6 }}>🤖 AI GST Mismatch Detection Report</div>
                      <div style={{ fontSize:13, opacity:.9, lineHeight:1.5 }}>{aiGst.summary?.overview}</div>
                    </div>
                    <div style={{ display:"flex", gap:10, flexWrap:"wrap", flexShrink:0 }}>
                      {[
                        ["System GST",  "₹"+(aiGst.summary?.totalSystemGst||0).toLocaleString("en-IN")],
                        ["Filed GST",   "₹"+(aiGst.summary?.totalFiledGst||0).toLocaleString("en-IN")],
                        ["Mismatch",    "₹"+Math.abs(mismatch).toLocaleString("en-IN")],
                      ].map(([l,v])=>(
                        <div key={l} style={{ background:"rgba(255,255,255,0.15)", borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                          <div style={{ fontSize:9, opacity:.8, textTransform:"uppercase", marginBottom:3 }}>{l}</div>
                          <div style={{ fontWeight:700, fontSize:14 }}>{v}</div>
                        </div>
                      ))}
                      <div style={{ background:"#fff", borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                        <div style={{ fontSize:9, color:"#6b7280", textTransform:"uppercase", marginBottom:3 }}>Compliance Score</div>
                        <div style={{ fontWeight:800, fontSize:20, color:score>=80?"#15803d":score>=60?"#d97706":"#dc2626" }}>{score}/100</div>
                      </div>
                      <div style={{ background:rbg, borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                        <div style={{ fontSize:9, color:rc, textTransform:"uppercase", marginBottom:3 }}>Risk</div>
                        <div style={{ fontWeight:700, fontSize:13, color:rc }}>{aiGst.summary?.riskLevel?.toUpperCase()}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Monthly Mismatches table */}
                {(aiGst.monthlyMismatches||[]).length > 0 && (
                  <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
                    <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#dc2626" }}>
                      📅 Monthly GST Mismatches
                    </div>
                    <div style={{ overflowX:"auto" }}>
                      <table style={{ width:"100%", borderCollapse:"collapse" }}>
                        <thead><tr>
                          {["Month","System Taxable","Filed Taxable","System GST","Filed GST","Mismatch","Type","Severity","Explanation"].map((h)=>(
                            <th key={h} style={{ ...S.th, whiteSpace:"nowrap" }}>{h}</th>
                          ))}
                        </tr></thead>
                        <tbody>
                          {(aiGst.monthlyMismatches||[]).map((m,i)=>{
                            const [sc,sbg] = sevColors[m.severity]||sevColors.medium;
                            const isUnder = m.mismatchType==="under_reported"||m.mismatchType==="missing_filing";
                            return (
                              <tr key={i} style={{ background:m.severity==="critical"?"#fef2f2":m.severity==="high"?"#fff7ed":"" }}
                                onMouseEnter={(e)=>e.currentTarget.style.background="#fafafa"}
                                onMouseLeave={(e)=>e.currentTarget.style.background=m.severity==="critical"?"#fef2f2":m.severity==="high"?"#fff7ed":""}>
                                <td style={{ ...S.td, fontWeight:600 }}>{m.month}</td>
                                <td style={S.td}>{INR(m.systemTaxable)}</td>
                                <td style={S.td}>{INR(m.filedTaxable)}</td>
                                <td style={{ ...S.td, color:"#2563eb", fontWeight:600 }}>{INR(m.systemGst)}</td>
                                <td style={S.td}>{INR(m.filedGst)}</td>
                                <td style={{ ...S.td, fontWeight:700, color:isUnder?"#dc2626":"#15803d" }}>
                                  {isUnder?"▼":"▲"} {INR(Math.abs(m.mismatchAmount))}
                                </td>
                                <td style={S.td}>
                                  <span style={{ background:isUnder?"#fef2f2":"#f0fdf4", color:isUnder?"#dc2626":"#15803d", padding:"2px 8px", borderRadius:10, fontSize:10, fontWeight:700 }}>
                                    {m.mismatchType?.replace(/_/g," ")}
                                  </span>
                                </td>
                                <td style={S.td}>
                                  <span style={{ background:sbg, color:sc, padding:"2px 8px", borderRadius:10, fontSize:10, fontWeight:700 }}>{m.severity}</span>
                                </td>
                                <td style={{ ...S.td, fontSize:11, color:"#6b7280", maxWidth:200, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{m.explanation}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr style={{ background:"#f9fafb", fontWeight:700 }}>
                            <td style={S.td} colSpan={5}>Total Mismatch</td>
                            <td style={{ ...S.td, fontSize:14, color:mismatch>0?"#dc2626":"#15803d", fontWeight:800 }}>
                              {mismatch>0?"▼":"▲"} {INR(Math.abs(mismatch))}
                            </td>
                            <td colSpan={3} style={S.td}/>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}

                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:14 }}>
                  {/* Platform Mismatches */}
                  {(aiGst.platformMismatches||[]).length > 0 && (
                    <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb" }}>
                      <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#d97706" }}>
                        🛒 Platform-wise Discrepancies
                      </div>
                      <div style={{ padding:14 }}>
                        {(aiGst.platformMismatches||[]).map((p,i)=>(
                          <div key={i} style={{ borderBottom:"1px solid #f3f4f6", paddingBottom:12, marginBottom:12 }}>
                            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                              <span style={{ fontWeight:700, fontSize:13 }}>{p.platform}</span>
                              <span style={{ fontWeight:700, color:"#dc2626" }}>{INR(p.amount)}</span>
                            </div>
                            <div style={{ fontSize:11, color:"#6b7280", marginBottom:4 }}>{p.explanation}</div>
                            <div style={{ background:"#fffbeb", borderRadius:5, padding:"5px 8px", fontSize:11, color:"#92400e" }}>💡 {p.action}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Recovery Opportunities */}
                  {(aiGst.recoveryOpportunities||[]).length > 0 && (
                    <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb" }}>
                      <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#15803d" }}>
                        💰 Recovery Opportunities
                      </div>
                      <div style={{ padding:14 }}>
                        {(aiGst.recoveryOpportunities||[]).map((r,i)=>{
                          const [pc,pbg] = priColors[r.priority]||priColors.short_term;
                          return (
                            <div key={i} style={{ borderBottom:"1px solid #f3f4f6", paddingBottom:12, marginBottom:12, borderLeft:`3px solid ${pc}`, paddingLeft:10 }}>
                              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                                <span style={{ fontWeight:700, fontSize:12 }}>{r.type}</span>
                                <span style={{ fontWeight:800, color:"#15803d", fontSize:14 }}>₹{(r.amount||0).toLocaleString("en-IN")}</span>
                              </div>
                              <div style={{ fontSize:11, color:"#6b7280", marginBottom:4 }}>{r.description}</div>
                              <div style={{ fontSize:11, color:"#15803d" }}>👉 {r.howToRecover}</div>
                            </div>
                          );
                        })}
                        <div style={{ background:"#f0fdf4", borderRadius:8, padding:"10px 14px", textAlign:"center" }}>
                          <div style={{ fontSize:11, color:"#6b7280" }}>Total Recoverable</div>
                          <div style={{ fontSize:20, fontWeight:800, color:"#15803d" }}>
                            {INR((aiGst.recoveryOpportunities||[]).reduce((a,r)=>a+(r.amount||0),0))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Compliance Issues */}
                {(aiGst.complianceIssues||[]).length > 0 && (
                  <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb", marginBottom:14 }}>
                    <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13, color:"#dc2626" }}>
                      ⚠️ Compliance Issues & Penalty Risks
                    </div>
                    <div style={{ padding:14, display:"flex", flexDirection:"column", gap:10 }}>
                      {(aiGst.complianceIssues||[]).map((c,i)=>{
                        const [ic,ibg] = riskColors[c.severity]||riskColors.medium;
                        return (
                          <div key={i} style={{ display:"flex", gap:12, padding:"10px 14px", background:"#f9fafb", borderRadius:8, borderLeft:`4px solid ${ic}` }}>
                            <span style={{ background:ibg, color:ic, padding:"2px 8px", borderRadius:10, fontSize:10, fontWeight:700, height:"fit-content", whiteSpace:"nowrap" }}>{c.severity}</span>
                            <div style={{ flex:1 }}>
                              <div style={{ fontWeight:700, fontSize:12, marginBottom:3 }}>{c.issue}</div>
                              <div style={{ fontSize:11, color:"#dc2626", marginBottom:3 }}>⚠ Penalty risk: {c.penalty_risk}</div>
                              <div style={{ fontSize:11, color:"#15803d" }}>✅ Fix: {c.fix}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Recommendations */}
                {(aiGst.recommendations||[]).length > 0 && (
                  <div style={{ background:"#fff", borderRadius:10, border:"1px solid #e5e7eb" }}>
                    <div style={{ padding:"11px 16px", borderBottom:"1px solid #e5e7eb", fontWeight:700, fontSize:13 }}>
                      ✅ AI Recommendations
                    </div>
                    <div style={{ padding:14, display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:10 }}>
                      {(aiGst.recommendations||[]).map((r,i)=>(
                        <div key={i} style={{ background:"#f9fafb", borderRadius:8, padding:"12px 14px", borderTop:"3px solid #6366f1" }}>
                          <div style={{ fontWeight:700, fontSize:12, marginBottom:4, color:"#1A3A5C" }}>{r.title}</div>
                          <div style={{ fontSize:11, color:"#6b7280", marginBottom:6 }}>{r.description}</div>
                          <div style={{ fontSize:11, color:"#6366f1", fontWeight:600 }}>📈 {r.impact}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}

// ── Excel export using CSV with BOM ───────────────────────────
function exportExcel(rows, headers, filename) {
  const bom  = "\uFEFF";
  const csv  = bom + [headers.join(","), ...rows.map((r) =>
    headers.map((h) => {
      const val = r[h] !== undefined ? String(r[h]) : "";
      return '"' + val.replace(/"/g, '""') + '"';
    }).join(",")
  )].join("\r\n");
  const blob = new Blob([csv], { type:"text/csv;charset=utf-8;" });
  const a    = document.createElement("a");
  a.href     = URL.createObjectURL(blob);
  a.download = filename + ".csv";
  a.click();
}
